'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  padding-top: 13px;\n  padding-left: 16px;\n  margin-left: 1px;\n  background-color: ', ';\n'], ['\n  position: absolute;\n  padding-top: 13px;\n  padding-left: 16px;\n  margin-left: 1px;\n  background-color: ', ';\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  padding-left: 18px;\n  border-color: ', ';\n'], ['\n  padding-left: 18px;\n  border-color: ', ';\n']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  border-color: ', ';\n'], ['\n  border-color: ', ';\n']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  & > input {\n    padding-left: ', ';\n  }\n'], ['\n  & > input {\n    padding-left: ', ';\n  }\n']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 8px;\n  color: ', ';\n  box-sizing: border-box;\n  background-color: ', ';\n  display: flex;\n  min-heigh: 48px;\n  font-size: 16px;\n  outline: none;\n  width: 100%;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  background-color: ', ';\n  &::-webkit-input-placeholder {\n    color: #d2d2d2;\n  }\n  &::placeholder {\n    color: #d2d2d2;\n  }\n'], ['\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 8px;\n  color: ', ';\n  box-sizing: border-box;\n  background-color: ', ';\n  display: flex;\n  min-heigh: 48px;\n  font-size: 16px;\n  outline: none;\n  width: 100%;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  background-color: ', ';\n  &::-webkit-input-placeholder {\n    color: #d2d2d2;\n  }\n  &::placeholder {\n    color: #d2d2d2;\n  }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _mask = require('../../../util/mask');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TextInput = function (_Component) {
  (0, _inherits3.default)(TextInput, _Component);
  function TextInput(props) {
    (0, _classCallCheck3.default)(this, TextInput);
    var _this = (0, _possibleConstructorReturn3.default)(this, (TextInput.__proto__ || (0, _getPrototypeOf2.default)(TextInput)).call(this, props));
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
    _this.state = {
      value: '',
      borderColor: '#D2D2D2'
    };
    return _this;
  }
  (0, _createClass3.default)(TextInput, [{
    key: 'handleOnKeyDown',
    value: function handleOnKeyDown(event) {
      var _props = this.props,
        onKeyDown = _props.onKeyDown,
        onKeyPress = _props.onKeyPress;
      if (onKeyDown) {
        onKeyDown(event);
      } else if (onKeyPress) {
        onKeyPress(event);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({
        value: this.props.mask ? (0, _mask.removeMask)(event.target.value) : event.target.value
      });
      if (this.props.onChange) {
        if (this.props.mask) {
          this.props.onChange((0, _mask.unmaskEvent)(event));
        } else {
          this.props.onChange(event);
        }
      }
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var value = event.target.value;
      if (value && value !== '' && value !== null) {
        this.setState({
          borderColor: '#999999'
        });
      } else {
        this.setState({
          borderColor: '#D2D2D2'
        });
      }
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
      this.setState({
        borderColor: '#6E0AD6'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        secureTextEntry = _props2.secureTextEntry,
        keyboardType = _props2.keyboardType,
        autoComplete = _props2.autoComplete,
        autoCapitalize = _props2.autoCapitalize,
        _props2$hidden = _props2.hidden,
        hidden = _props2$hidden === undefined ? false : _props2$hidden,
        rows = _props2.rows,
        multiline = _props2.multiline,
        className = _props2.className,
        placeholder = _props2.placeholder,
        type = _props2.type,
        pattern = _props2.pattern,
        step = _props2.step,
        maxLength = _props2.maxLength,
        max = _props2.max,
        min = _props2.min,
        disabled = _props2.disabled,
        ref = _props2.ref,
        name = _props2.name,
        hasError = _props2.hasError,
        icon = _props2.icon,
        mask = _props2.mask;
      var _state = this.state,
        value = _state.value,
        borderColor = _state.borderColor;
      var keyboardTypeDict = {
        'email-address': 'email'
      };
      var inputType = keyboardType in keyboardTypeDict ? keyboardTypeDict[keyboardType] : type || 'text';
      if (multiline) {
        return _react2.default.createElement(Textarea, {
          hasError: hasError,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          className: className,
          placeholder: placeholder,
          value: value,
          ref: ref,
          name: name,
          borderColor: borderColor,
          rows: rows
        });
      }
      return _react2.default.createElement(InputWrapper, null, icon && _react2.default.createElement(Figure, {
        icon: icon,
        disabled: disabled
      }), _react2.default.createElement(StyledInput, {
        hasError: hasError,
        type: secureTextEntry ? 'password' : inputType,
        value: mask ? (0, _mask.addMask)(value, mask) : value,
        pattern: pattern,
        maxLength: maxLength,
        step: step,
        max: max,
        min: min,
        className: className,
        placeholder: placeholder,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        disabled: disabled,
        borderColor: borderColor,
        autoComplete: autoComplete,
        autoCapitalize: autoCapitalize,
        hidden: hidden,
        ref: ref,
        name: name
      }));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      return {
        value: props.value || ''
      };
    }
  }]);
  return TextInput;
}(_react.Component);
TextInput.propTypes = {
  secureTextEntry: _propTypes2.default.string,
  multiline: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  type: _propTypes2.default.string,
  pattern: _propTypes2.default.string,
  step: _propTypes2.default.number,
  maxLength: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  rows: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  max: _propTypes2.default.string,
  min: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  keyboardType: _propTypes2.default.string,
  autoComplete: _propTypes2.default.string,
  autoCapitalize: _propTypes2.default.string,
  ref: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.string]),
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  hasError: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  icon: _propTypes2.default.func,
  mask: _propTypes2.default.string
};
var hasIcon = function hasIcon(children) {
  return children.some(function (child) {
    return child && child.props.icon;
  });
};
var FigureWrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.disabled ? '#f6f6f6' : '';
});
var Textarea = _styledComponents2.default.textarea(_templateObject2, function (props) {
  return props.hasError ? '#ff4444' : props.borderColor;
});
var StyledInput = _styledComponents2.default.input(_templateObject3, function (props) {
  return props.hasError ? '#ff4444' : props.borderColor;
});
var Figure = function Figure(_ref) {
  var icon = _ref.icon,
    disabled = _ref.disabled;
  var I = icon;
  return _react2.default.createElement(FigureWrapper, {
    disabled: disabled
  }, _react2.default.createElement(I, null));
};
var InputWrapper = _styledComponents2.default.div(_templateObject4, function (props) {
  return hasIcon(props.children) ? '48px' : '18px';
});
var Input = (0, _styledComponents2.default)(TextInput)(_templateObject5, function (props) {
  return props.disabled ? '#d2d2d2' : '#4a4a4a';
}, function (props) {
  return props.disabled ? '#f6f6f6' : '';
}, function (props) {
  return props.disabled ? '#f6f6f6' : '';
});
Input.propTypes = {
  secureTextEntry: _propTypes2.default.string,
  multiline: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  type: _propTypes2.default.string,
  pattern: _propTypes2.default.string,
  step: _propTypes2.default.number,
  maxLength: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  rows: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  max: _propTypes2.default.string,
  min: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  keyboardType: _propTypes2.default.string,
  autoComplete: _propTypes2.default.string,
  autoCapitalize: _propTypes2.default.string,
  ref: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.string]),
  name: _propTypes2.default.string,
  hasError: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  mask: _propTypes2.default.string
};
Figure.propTypes = {
  icon: _propTypes2.default.element.isRequired,
  disabled: _propTypes2.default.string
};
FigureWrapper.propTypes = {
  disabled: _propTypes2.default.string
};
exports.default = Input;